import { render } from "./PerformanceRatioSolarPanel.vue?vue&type=template&id=7c92394c"
import script from "./PerformanceRatioSolarPanel.vue?vue&type=script&lang=js"
export * from "./PerformanceRatioSolarPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__